/**
 * Los requisitos de una contraseña, para poder enseñarlos mientras se
 * escribe.
 *
 * **La API sigue siendo la que decide.** Esto es una ayuda, no un
 * candado: repite las reglas de `password.service.ts` para que quien
 * captura vea cuál le falta antes de pulsar, en vez de descubrirlo con un
 * «no cumple los requisitos mínimos» que no dice cuál.
 *
 * Duplicar reglas tiene su costo —el día que cambien hay que tocar dos
 * sitios— y se acepta a propósito: la alternativa era pedírselas a la API
 * en cada tecla, o dejar a la gente adivinando. Si alguna se desincroniza,
 * el error de la API sigue llegando y ahora sí se lee, porque los motivos
 * ya se muestran.
 *
 * Dos reglas no se pueden comprobar aquí y por eso se enuncian sin marca:
 * que no sea una contraseña conocida —la lista vive en el servidor— y que
 * no contenga el nombre. El correo sí, porque la pantalla lo tiene.
 */

export interface Requisito {
  texto: string;
  cumple: boolean;
}

export function requisitosDe(clave: string, correo = ''): Requisito[] {
  const usuario = correo.toLowerCase().split('@')[0];

  return [
    { texto: 'Al menos 12 caracteres', cumple: clave.length >= 12 },
    { texto: 'Una letra minúscula', cumple: /[a-záéíóúñ]/.test(clave) },
    { texto: 'Una letra mayúscula', cumple: /[A-ZÁÉÍÓÚÑ]/.test(clave) },
    { texto: 'Un número', cumple: /\d/.test(clave) },
    { texto: 'Un símbolo, por ejemplo . - # $', cumple: /[^\w\s]/.test(clave) },
    {
      texto: 'No contiene tu correo',
      cumple: !(usuario.length >= 4 && clave.toLowerCase().includes(usuario)),
    },
  ];
}

/** Si la contraseña pasa lo que esta pantalla sabe comprobar. */
export function cumpleTodo(clave: string, correo = ''): boolean {
  return requisitosDe(clave, correo).every((r) => r.cumple);
}
